<msi-content-modal #modal [modalRef]="modalRef" [items]="releaseNotes" (indexChanged)="modalIndexChanged($event)">
	<msi-content-modal-title>
		<span class="msi-content-modal-title">{{ releaseNotes[modal.index].releaseTitle }}</span>
	</msi-content-modal-title>
	<button
		id="refreshReleaseNotesContentButton"
		class="msi-btn msi-btn-icon msi-content-modal-button msi-content-modal-button-refresh"
		[hidden]="!!releaseNotes[modal.index].fileContents"
		(click)="refreshModalContent(modal.index)">
		<msi-icon name="ic_refresh" [size]="36" [color]="'white'"></msi-icon>
	</button>
	<div
		class="msi-content-modal-item release-notes-container"
		[innerHTML]="releaseNotes[modal.index].fileContents"></div>
</msi-content-modal>

<!-- Copyright (c) Motorola Solutions Inc. All Rights Reserved. -->
